import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import VaultDocsDetailModule from "../comp/vault-docs-detail";

export default function DocsInfo() {

  return (
    <>
      <HeaderInner name={'View Credential'} link={'/vault'}/>
      <ViewContentSmall 
        content={
          <>
            <VaultDocsDetailModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}